<template>
  <v-container
    id="order-list-all"
    fluid
    tag="section"
  >
    <base-material-card outlined icon="mdi-account-outline" class="overflow-visible pb-7">
      <template v-slot:after-heading>
        <div class="font-weight-light card-title mt-2">Danh sách đơn hàng</div>
      </template>
      <v-row>
        <v-col cols="8">
          <v-tabs
            @change="changeTab"
            v-model="tabIndex"
            class="mt-3" color="primary"
          >
            <v-tab v-for="(tab, i) in tabs" :key="i">{{ tab }}</v-tab>
          </v-tabs>
        </v-col>

        <v-col cols="4">
          <div style="float:right">
            <v-menu
              :internal-activator="true"
              v-model="openMenu"
              content-class="menu__customer--filter no-contain overflow-visible"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-btn style="margin-right: 10px;" color="primary" dark v-on="on">
                  <span>Lọc theo điều kiện</span>
                  <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <card-filter-form
                :filterForm="filterForm"
                :openMenu="openMenu"
                :filterAgencyStatusList="contactStatusAgency"
                :usersAgency="usersAgency"
              />
            </v-menu>
            <!-- <v-btn
              color="primary"
              class="mr-3"
              dark
              @click="clickAddOrder"
              v-if="checkConditionT4NT5(_.get(dataForm, 'contactStatus.type', '')) && checkAuthorization('order_create')">
              <v-icon>mdi-plus</v-icon>Tạo đơn
            </v-btn> -->
          </div>
        </v-col>
      </v-row>

      <v-col cols="12">
        <order-table-all
          :orders="orders"
          :totalPrice="totalPrice"
          :contactStatusAgency="contactStatusAgency"
        />
      </v-col>

      <v-row class="mt-4">
        <v-col
          cols="12"
          sm="6"
        />
        <v-col
          cols="12"
          sm="6"
        >
          <v-pagination
            v-if="totalItem > limit"
            v-model="currentPage"
            class="justify-sm-end"
            :length="getTotalItem(totalItem, limit)"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
          />
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
import OrderTableAll from './components/OrderTableAll';
import RepositoryFactory from '../../repositories/RepositoryFactory';
import CardFilterForm from './components/CardFilterForm';
const AgencyRepository = RepositoryFactory.get('agency')

export default {
  components: { OrderTableAll, CardFilterForm },
  data() {
    return {
      usersAgency: [],
      dataForm: {},
      tabIndex: 0,
      tabs: ['Tất cả', "Đã lên đơn", "Đã hủy", "Đã thành công"],
      orders: [],
      customers: [],
      totalPrice: 0,
      contactStatusAgency: [],
      currentPage: 1,
      limit: 10,
      openMenu: false,
      totalItem: 0
    };
  },
  props: {
    filterForm: {
      default: () => ({})
    }
  },
  watch: {
    currentPage: {
      handler () {
        this.getOrderList(this.filterForm)
      },
    },
    limit: {
      handler () {
        if (this.currentPage === 1) {
          this.getOrderList(this.filterForm)
        } else {
          this.currentPage = 1
        }
      },
    },
  },
  computed: {},
  mounted() {},
  async created() {
    this.dataForm = {
      order: {},
      position: 'other',
      contactSourceIds: [],
      groupIds: [],
      customers: [
        {
          mobile: '',
          isMainCustomer: true,
          position: 'other',
          phones: [],
          courseRegister: []
        }
      ]
    };
    this.appLoadingData(true)
    await Promise.all([
      this.getOrderList(),
      this.getUsersAgency(),
      this.getListContactStatusAgency()
    ]);
    this.appLoadingData(false)

    //event update order in agency
    Bus.$on('order-tab-filter', (filter) => {
      this.getOrderList();
    })

    // event search order in agency
    Bus.$on('order-list-filter', (filterForm) => {
      this.filterForm = filterForm
      this.getOrderList(filterForm)
    })

    //close filter form
    Bus.$on('close-filter-form-agency', () => {
      this.openMenu = false;
    })
  },
  beforeDestroy() {
    Bus.$off('order-list-filter');
    Bus.$off('order-tab-filter');
  },
  methods: {
    remove(item) {
      const filterFormTemp = this.filterForm;
      const index = filterFormTemp.userIds.indexOf(item.id);
      if (index >= 0) filterFormTemp.userIds.splice(index, 1);
    },
    changeTab() {
      if (this.tabIndex == 0) {
        if(this.filterForm.statusId) delete this.filterForm.statusId
      }
      if (this.tabIndex == 1) {
        this.filterForm.statusId = 1
      }
      if (this.tabIndex == 2) {
        this.filterForm.statusId = 5
      }
      if (this.tabIndex == 3) {
        this.filterForm.statusId = 3
      }
      this.getOrderList(this.filterForm)
    },
    async getOrderList(filterForm = {}) {
      const loading = this.$loading.show();
      const response = await AgencyRepository.getOrderList({
        limit: this.limit,
        page: this.currentPage - 1,
        ...filterForm
      });

      loading.hide()
      if (response.success) {
        this.totalItem = response.data.totalItem
        let listOrder = _.get(response, 'data.data', [])
        this.orders = listOrder.map(item => {
          return {
            ...item,
            rowspan: item.products && item.products.length ? item.products.length : 1
          }
        })
        this.totalPrice = _.get(response, 'data.totalPrice', [])
      }
    },
    clickAddOrder() {
      let self = this
      if (this.dataForm.mainId) {
        this.$swal({
          title: 'Số điện thoại đã được gộp vào contact ' + self.dataForm.phoneRelated[0] + '.<br>Vui lòng thực hiện các thao tác tại contact chính.',
          confirmButtonText: 'Xem contact chính',
          showCancelButton: true,
          cancelButtonText: 'Quay lại'
        }).then((res) => {
          if (res.value) {
            let routeData = self.$router.resolve({
              name: 'ContactDetail',
              params: {
                id: self.dataForm.mainId || 0
              }
            })
            window.open(routeData.href, '_blank')
          }
        })
      } else {
        this.$router.push({
          name: 'AgencyOrderCreate',
          params: { id: _.get(this, '$route.params.id', '') }
        });
      }
    },
    async getUsersAgency() {
      const userAgencyList = await AgencyRepository.getListUserByPermission({
        model:'agency-user', action:'read'
      })
      if (userAgencyList.data && userAgencyList.data.success) {
        this.usersAgency = _.get(userAgencyList, 'data.data', [])
      }
    },
    async getListContactStatusAgency() {
      const res = await AgencyRepository.listStatus({limit: 1000})
      if (res.success) {
        this.contactStatusAgency = _.get(res, 'data', [])
      }
    }
  }
};
</script>
<style scoped>
.menu__customer--filter {
  top: calc(11%) !important;
}
</style>